import styled from 'styled-components';
import { medias } from '@/utils/sizes';

export const VirtualTourModalContainer = styled.div`
  --gallery-slider-modal-pd: 4vh;
  --gallery-slider-side-width: 250px;

  position: fixed;
  display: flex;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 100vw;
  max-width: 100vw !important;
  height: 100vh;
  opacity: 0;
  pointer-events: none;
  background-color: var(--bg-main);
  z-index: 1000;
  padding: 0 var(--gallery-slider-modal-pd);
  background-color: hsla(188 100% 0% / 0.8);
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
  transition: opacity 0.3s ease-in-out;
  animation: fade-in 0.3s ease-in-out;

  iframe {
    /* width: calc(100vw - 200px); */
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: none;
  }

  ${medias.max.desktopSm} {
    grid-template-columns: 100%;
    padding: 0;
    padding-top: 4vh;

    & {
      --gallery-slider-modal-pd: 4vh var(--page-pd-mobile-tablet);
    }
  }

  ${medias.max.tablet} {
    & {
      --gallery-slider-modal-pd: var(--page-pd-mobile-tablet)
        var(--page-pd-mobile-tablet);
    }
  }

  ${medias.max.mobile} {
    width: calc(100vw - 15px);
    padding-top: 0;

    iframe {
      width: calc(100vw - 20px);
    }
  }

  .close-btn {
    --close-btn-pos: calc(5vh - 25px);
    position: absolute;
    height: 50px;
    width: 50px;
    top: 4vh;
    right: 4vh;
    transform: translate(15px, -15px);
    z-index: 1000;

    ${medias.max.mobile} {
      right: var(--page-pd-mobile-tablet);
    }

    img {
      filter: invert(1);
    }
  }

  &[data-is-displayed='false'] {
    opacity: 0;
    pointer-events: none;
  }

  .title {
    align-self: flex-start;
    grid-row: 1;
    grid-column: 1;

    ${medias.max.desktopSm} {
      left: 2vw;
      position: absolute;
    }
  }

  &[data-is-open='true'] {
    opacity: 1;
    pointer-events: all;
  }
`;
